import { Route } from "@angular/router";
import { ExcluirContaPage } from "./excluir-conta.page";

export const ExcluirContaRouter: Route[] = [
  { path: 'excluir-conta', component: ExcluirContaPage }
];
